var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMute = function SvgMute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.8 23.7",
    style: {
      enableBackground: "new 0 0 16.8 23.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CDD9E5",
    d: "M9.1,19.7c4.3-0.4,7.7-4,7.7-8.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,4-3.3,7.3-7.3,7.3 c-4,0-7.3-3.3-7.3-7.3c0-0.3-0.3-0.6-0.6-0.6S0,11,0,11.3c0,4.3,3.4,8,7.7,8.4l0.1,0v2.8H4.5c-0.3,0-0.6,0.3-0.6,0.6 s0.3,0.6,0.6,0.6h7.8c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6H9v-2.8L9.1,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD9E5",
    d: "M8.4,15.8c2.5,0,4.5-2,4.5-4.5V4.5c0-2.5-2-4.5-4.5-4.5S3.9,2,3.9,4.5v6.8C3.9,13.8,5.9,15.8,8.4,15.8z  M5.1,4.5c0-1.8,1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4v6.8c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4V4.5z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mute.1b53f95e.svg";
export { ForwardRef as ReactComponent };